import { render, staticRenderFns } from "./SoContent.vue?vue&type=template&id=6719c1d8"
import script from "./SoContent.vue?vue&type=script&lang=js"
export * from "./SoContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports